import AsyncStorage from '@react-native-async-storage/async-storage';
import { mapKeys, unionBy } from "lodash";
import { GetPricetag } from "../../constants/Utils";
import { ICategory } from '../../interfaces/category';
import { IManufacturer } from '../../interfaces/manufacturer';
import { IProduct, IProductContextState, ProductContextActions, ProductContextActionTypes } from '../../interfaces/product';

const Reducer = (state: IProductContextState, action: ProductContextActions) => {
    let _products: IProduct[]
    let _categories: ICategory[]
    let _manufacturers: IManufacturer[]
    switch (action.type) {
        case ProductContextActionTypes.SET_PRODUCTS:
            _products = []
            if (action.payload) {
                _products = action.payload.filter(product => {
                    let product_pricetag = GetPricetag(product)
                    if (
                        product_pricetag &&
                        product.status === 'active'
                    ) {
                        product['pricetag'] = product_pricetag
                        return product
                    }
                    return false
                })
            }

            return {
                ...state,
                products: _products
            };
        case ProductContextActionTypes.SET_ALL_PRODUCTS:
            _products = []
            if (action.payload) {
                _products = action.payload.filter(product => {
                    let product_pricetag = GetPricetag(product)
                    if (
                        product_pricetag &&
                        product.status === 'active'
                    ) {
                        product['pricetag'] = product_pricetag
                        return product
                    }
                    return false
                })
            }

            return {
                ...state,
                all_products: _products
            };
        case ProductContextActionTypes.SET_PAGED_PRODUCTS:
            _products = []
            if (action.payload && action.payload.data) {
                _products = action.payload.data.filter(product => {
                    let product_pricetag = GetPricetag(product)
                    if (
                        product_pricetag &&
                        product.status === 'active'
                    ) {
                        product['pricetag'] = product_pricetag
                        return product
                    }
                    return false
                })
            }

            return {
                ...state,
                product_page: action.payload.page < state.product_page
                    ? action.payload.page < action.payload.total
                        ? state.product_page
                        : action.payload.total
                    : action.payload.page,
                product_limit: action.payload.limit,
                product_page_total: action.payload.total,
                product_page_count: action.payload.count,
                all_products: unionBy(state.all_products, _products, '_id')
            };
        case ProductContextActionTypes.SET_PAGED_MANUFACTURERS:
            _manufacturers = []
            if (action.payload && action.payload.data) {
                _manufacturers = action.payload.data.filter(manufacturer => manufacturer.status === 'active')
            }

            return {
                ...state,
                manufacturer_page: action.payload.page < state.manufacturer_page
                    ? action.payload.page < action.payload.total
                        ? state.manufacturer_page
                        : action.payload.total
                    : action.payload.page,
                manufacturer_limit: action.payload.limit,
                manufacturer_page_total: action.payload.total,
                manufacturer_page_count: action.payload.count,
                manufacturers: unionBy(state.manufacturers, _manufacturers, '_id')
            };
        case ProductContextActionTypes.SET_PAGED_CATEGORIES:
            _categories = []
            if (action.payload && action.payload.data) {
                _categories = action.payload.data.filter(category => category.status === 'active')
            }

            return {
                ...state,
                category_page: action.payload.page < state.category_page
                    ? action.payload.page < action.payload.total
                        ? state.category_page
                        : action.payload.total
                    : action.payload.page,
                category_limit: action.payload.limit,
                category_page_total: action.payload.total,
                category_page_count: action.payload.count,
                categories: unionBy(state.categories, _categories, '_id')
            };
        case ProductContextActionTypes.SET_QUERY:
            return {
                ...state,
                query: action.payload
            };
        case ProductContextActionTypes.SET_MANUFACTURERS:
            return {
                ...state,
                manufacturers: action.payload
            };
        case ProductContextActionTypes.SET_TOP_MANUFACTURERS:
            return {
                ...state,
                top_manufacturers: action.payload
            };
        case ProductContextActionTypes.SET_BRANDS:
            return {
                ...state,
                brands: action.payload
            };
        case ProductContextActionTypes.SET_BRANDS_DICT:
            return {
                ...state,
                brands_dict: action.payload
            };
        case ProductContextActionTypes.SET_ROUTE_FULFILMENTS:
            return {
                ...state,
                route_fulfilments: action.payload
            };
        case ProductContextActionTypes.SET_SEARCH_CONTEXT:
            return {
                ...state,
                search_context: action?.payload,
                search_result: action?.payload?.model ? state?.all_products.filter((x: any) => x[action?.payload?.model]?._id === action?.payload?.model_data._id) : []
            };
        case ProductContextActionTypes.SET_SEARCH_RESULT:
            return {
                ...state,
                search_result: action.payload,
                search_result_exact: action.payload.filter((x: any) => x.score < 0.02),
                search_result_match: action.payload.filter((x: any) => x.score >= 0.02),
            };
        case ProductContextActionTypes.SET_PRODUCT_VIEW:
            AsyncStorage.setItem('productViewUser', action.payload)
            return {
                ...state,
                product_view: action.payload
            };
        case ProductContextActionTypes.SET_SELLER_PRODUCT:
            return {
                ...state,
                seller_product: action.payload,
                seller_product_dict: mapKeys(action.payload, function (value: any, key) {
                    return value?.product_id
                })
            };
        case ProductContextActionTypes.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case ProductContextActionTypes.SET_LOADING_NEXT_PRODUCT:
            return {
                ...state,
                loading_next_product: action.payload
            };
        case ProductContextActionTypes.SET_LOADING_NEXT_BRAND:
            return {
                ...state,
                loading_next_brand: action.payload
            };
        case ProductContextActionTypes.SET_LOADING_NEXT_MANUFACTURER:
            return {
                ...state,
                loading_next_manufacturer: action.payload
            };
        case ProductContextActionTypes.SET_LOADING_NEXT_CATEGORY:
            return {
                ...state,
                loading_next_category: action.payload
            };
        case ProductContextActionTypes.CLEAR_ALL:
            AsyncStorage.removeItem('manufacturers');
            AsyncStorage.removeItem('routeFulfilment');
            AsyncStorage.removeItem('brandsDict');
            AsyncStorage.removeItem('allProducts');
            AsyncStorage.removeItem('sellerProduct');

            return {
                ...state,
                query: '',
                products: [],
                all_products: [],
                brands: [],
                brands_dict: {},
                manufacturers: [],
                route_fulfilments: {},
                search_context: null,
                search_result: [],
                search_result_exact: [],
                search_result_match: [],
                product_view: 'list',
                product_view_default: 'list',
                seller_product: [],
                seller_product_dict: {},
            };
        default:
            return state;
    }
};

export default Reducer;